import React from 'react';
import Alert from './Alert';

const ErrorAlert = props => <Alert {...props} variant="error" />;
export default ErrorAlert;
